import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { getFeatured, getLatest, getPopular } from "@/lib/content";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickEntry from "./components/CategoryQuickEntry";
import LatestFeed from "./components/LatestFeed";
import PopularSection from "./components/PopularSection";
import BrandIntro from "./components/BrandIntro";

export default function Home() {
  usePageMeta({
    title: "小蜜桃 - 多元娱乐资讯与品牌服务平台",
    description:
      "小蜜桃网站提供丰富的娱乐资讯和多样化内容，包括影视、音乐及生活方式等，满足用户多元化的娱乐需求和品牌信息查询。",
    keywords: "小蜜桃,娱乐资讯,影视新闻,音乐推荐,品牌信息,生活方式,综合娱乐",
  });

  const featured = getFeatured();
  const latest = getLatest(7);
  const popular = getPopular(7);

  return (
    <SiteLayout>
      <HeroCarousel items={featured} />
      <CategoryQuickEntry />
      <LatestFeed items={latest} />
      <PopularSection items={popular} />
      <BrandIntro />
    </SiteLayout>
  );
}